import { __zcFin, __zcFz, __zcIT, __zcITc, __zcIV, __zcMkv } from "__zod-compiler-runtime__";
import {LinkSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/link'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'

const BaseFormFieldSchema = z.lazy(() =>
  z.object({
    name: z.string(),
    label: z.string(),
    placeholder: z.string().optional(),
    required: z.boolean().optional(),
  }),
)

export const TemplateUniverse23WaitlistSchema = /* @__PURE__ */ (() => {
var __zs=buildEntrySchemaFor('templateUniverse23Waitlist', {
  fields: z.lazy(() =>
    z.object({
      body: safeOptional(RichTextSchema),
      formName: z.string(),
      headline: z.string(),
      hiddenFormFields: safeOptional(z.looseObject({}).catchall(z.string())),
      label: z.string().optional(),
      theme: z.union([z.literal('ai'), z.literal('collaboration'), z.literal('security')]).optional(),
      thankYouHeadline: z.string().optional(),
      thankYouBody: safeOptional(RichTextSchema),
      thankYouCta: safeOptional(LinkSchema),
      thankYouLoggedOutCta: safeOptional(LinkSchema),
      signInBanner: safeOptional(RichTextSchema),
      /**
       * We currently support the following types of fields:
       *
       * - Simple text inputs:
       *
       *  {
       *    type: 'text',
       *    name: 'title',
       *    label: 'Job Title',
       *    placeholder: 'e.g. Software Engineer',
       *    required: true,
       *  }
       *
       * - Simple number inputs:
       *
       *  {
       *    type: 'number',
       *    name: 'yearsOfExperience',
       *    label: 'Years of experience',
       *    required: true,
       *  }
       *
       * - Radio buttons:
       *
       *  {
       *    type: 'radios',
       *    name: 'number_developers',
       *    label: 'Number of developers',
       *    options: {
       *      '0_10': '0-10',
       *      '10_50': '10-50',
       *      '50_100': '50-100',
       *      '_100': 'More than 100',
       *    },
       *    required: true,
       *  }
       *
       * - Group of checkboxes
       *
       *  {
       *    label: "I'm interested in",
       *    name: 'github_product_of_interest',
       *    type: 'checkboxes',
       *    options: {
       *      code_scanning_autofix: 'Code Scanning: Autofix',
       *      secret_scanning_regex: 'Secret Scanning: Regular Expression Generator for Custom Patterns',
       *      secret_scanning_generic_secrets: 'Secret Scanning: Generic Secrets (Passwords)',
       *    },
       *  },
       *
       */
      additionalFormFields: safeOptional(
        z.array(
          z.discriminatedUnion('type', [
            BaseFormFieldSchema.unwrap().extend({type: z.enum(['text', 'number'])}),
            BaseFormFieldSchema.unwrap().extend({
              type: z.literal('radios'),
              options: z.looseObject({}).catchall(z.string()),
            }),
            BaseFormFieldSchema.unwrap().extend({
              type: z.literal('checkboxes'),
              options: z.looseObject({}).catchall(z.string()),
            }),
          ]),
        ),
      ),
    }),
  ),
});
var __rf=[__zs._zod.innerType.shape["sys"].shape["contentType"],__zs._zod.innerType.shape["fields"]._zod.innerType.shape["body"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs._zod.innerType.shape["fields"]._zod.innerType.shape["hiddenFormFields"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs._zod.innerType.shape["fields"]._zod.innerType.shape["thankYouBody"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs._zod.innerType.shape["fields"]._zod.innerType.shape["thankYouCta"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs._zod.innerType.shape["fields"]._zod.innerType.shape["thankYouLoggedOutCta"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs._zod.innerType.shape["fields"]._zod.innerType.shape["signInBanner"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs._zod.innerType.shape["fields"]._zod.innerType.shape["additionalFormFields"]._zod.def.innerType._zod.def.out._zod.def.transform];
var __rfp_0=__rf[0].safeParse.bind(__rf[0]);
var __rfn_13=__rf[1];
var __rfn_18=__rf[2];
var __rfn_42=__rf[3];
var __rfn_45=__rf[4];
var __rfn_48=__rf[5];
var __rfn_51=__rf[6];
var __rfn_54=__rf[7];
function safeParse_TemplateUniverse23WaitlistSchema(input){
var _e=[];
var _d=input;
if(typeof _d!=="object"||_d===null||Array.isArray(_d)){_e.push(__zcIT("object",_d,[]));}else{var __sv_1=_d["sys"];if(typeof __sv_1!=="object"||__sv_1===null||Array.isArray(__sv_1)){_e.push(__zcIT("object",__sv_1,["sys"]));}else{var __sv_3=__sv_1["id"];if(typeof __sv_3!=="string"){_e.push(__zcIT("string",__sv_3,["sys","id"]));}
var __sv_4=__sv_1["updatedAt"];if(__sv_4!==undefined){if(typeof __sv_4!=="string"){_e.push(__zcIT("string",__sv_4,["sys","updatedAt"]));}
}
var __sv_5=__sv_1["createdAt"];if(__sv_5!==undefined){if(typeof __sv_5!=="string"){_e.push(__zcIT("string",__sv_5,["sys","createdAt"]));}
}
var __sv_6=__sv_1["contentType"];var __op_8="contentType" in __sv_1;var __ob_7=_e.length;var __rf_r0=__rfp_0(__sv_6);if(!__rf_r0.success){var __rf_i0=__rf_r0.error.issues;for(var __rf_j0=0;__rf_j0<__rf_i0.length;__rf_j0++){_e.push({...__rf_i0[__rf_j0],path:["sys","contentType"].concat(__rf_i0[__rf_j0].path)});}}else{__sv_6=__rf_r0.data;}
if(!__op_8){__sv_6=undefined;if(_e.length===__ob_7){_e.push(__zcITc("nonoptional",undefined,["sys","contentType"]));}}var __o_2={"id":__sv_3};if(__sv_4!==undefined||("updatedAt" in __sv_1)){__o_2["updatedAt"]=__sv_4;}if(__sv_5!==undefined||("createdAt" in __sv_1)){__o_2["createdAt"]=__sv_5;}if(__sv_6!==undefined||("contentType" in __sv_1)){__o_2["contentType"]=__sv_6;}__sv_1=__o_2;}
var __sv_9=_d["fields"];if(typeof __sv_9!=="object"||__sv_9===null||Array.isArray(__sv_9)){_e.push(__zcIT("object",__sv_9,["fields"]));}else{var __sv_11=__sv_9["body"];if(__sv_11!==undefined){var __ib_12=_e.length;if(_e.length===__ib_12){__sv_11=__rfn_13(__sv_11);}
}
var __sv_14=__sv_9["formName"];if(typeof __sv_14!=="string"){_e.push(__zcIT("string",__sv_14,["fields","formName"]));}
var __sv_15=__sv_9["headline"];if(typeof __sv_15!=="string"){_e.push(__zcIT("string",__sv_15,["fields","headline"]));}
var __sv_16=__sv_9["hiddenFormFields"];if(__sv_16!==undefined){var __ib_17=_e.length;if(_e.length===__ib_17){__sv_16=__rfn_18(__sv_16);}
}
var __sv_19=__sv_9["label"];if(__sv_19!==undefined){if(typeof __sv_19!=="string"){_e.push(__zcIT("string",__sv_19,["fields","label"]));}
}
var __sv_20=__sv_9["theme"];if(__sv_20!==undefined){var __u_21=false;var __ue_22=[];var __uea_23=[];if(!__u_21){var __ui_25=[];var __uoa_26=false;if(!(__sv_20==="ai")){__ui_25.push(__zcIV(["ai"],__sv_20,[]));}if(__ui_25.length===0){__u_21=true;}else{__ue_22.push(__ui_25);__uea_23.push(__uoa_26);}}if(!__u_21){var __ui_27=[];var __uoa_28=false;if(!(__sv_20==="collaboration")){__ui_27.push(__zcIV(["collaboration"],__sv_20,[]));}if(__ui_27.length===0){__u_21=true;}else{__ue_22.push(__ui_27);__uea_23.push(__uoa_28);}}if(!__u_21){var __ui_29=[];var __uoa_30=false;if(!(__sv_20==="security")){__ui_29.push(__zcIV(["security"],__sv_20,[]));}if(__ui_29.length===0){__u_21=true;}else{__ue_22.push(__ui_29);__uea_23.push(__uoa_30);}}if(!__u_21){var __up_24=["fields","theme"];var __una_31=[];for(var __uoi_32=0;__uoi_32<__ue_22.length;__uoi_32++){var __uab_34=__uea_23[__uoi_32]===true;if(!__uab_34){for(var __uoj_33=0;__uoj_33<__ue_22[__uoi_32].length;__uoj_33++){var __uoq_36=__ue_22[__uoi_32][__uoj_33];if(__uoq_36.continue===false){__uab_34=true;break;}var __uoc_35=__uoq_36.code;if(__uoc_35==="invalid_type"||__uoc_35==="invalid_value"||__uoc_35==="invalid_union"||__uoc_35==="invalid_key"||__uoc_35==="invalid_element"){__uab_34=true;break;}}}if(!__uab_34){__una_31.push(__ue_22[__uoi_32]);}}if(__una_31.length===1){for(var __uok_37=0;__uok_37<__una_31[0].length;__uok_37++){__una_31[0][__uok_37].path=__up_24.concat(__una_31[0][__uok_37].path);_e.push(__una_31[0][__uok_37]);}}else{for(var __uof_38=0;__uof_38<__ue_22.length;__uof_38++){__zcFz(__ue_22[__uof_38]);}_e.push({code:"invalid_union",errors:__ue_22,input:__sv_20,path:__up_24});}}
}
var __sv_39=__sv_9["thankYouHeadline"];if(__sv_39!==undefined){if(typeof __sv_39!=="string"){_e.push(__zcIT("string",__sv_39,["fields","thankYouHeadline"]));}
}
var __sv_40=__sv_9["thankYouBody"];if(__sv_40!==undefined){var __ib_41=_e.length;if(_e.length===__ib_41){__sv_40=__rfn_42(__sv_40);}
}
var __sv_43=__sv_9["thankYouCta"];if(__sv_43!==undefined){var __ib_44=_e.length;if(_e.length===__ib_44){__sv_43=__rfn_45(__sv_43);}
}
var __sv_46=__sv_9["thankYouLoggedOutCta"];if(__sv_46!==undefined){var __ib_47=_e.length;if(_e.length===__ib_47){__sv_46=__rfn_48(__sv_46);}
}
var __sv_49=__sv_9["signInBanner"];if(__sv_49!==undefined){var __ib_50=_e.length;if(_e.length===__ib_50){__sv_49=__rfn_51(__sv_49);}
}
var __sv_52=__sv_9["additionalFormFields"];if(__sv_52!==undefined){var __ib_53=_e.length;if(_e.length===__ib_53){__sv_52=__rfn_54(__sv_52);}
}
var __o_10={};if(__sv_11!==undefined||("body" in __sv_9)){__o_10["body"]=__sv_11;}__o_10["formName"]=__sv_14;__o_10["headline"]=__sv_15;if(__sv_16!==undefined||("hiddenFormFields" in __sv_9)){__o_10["hiddenFormFields"]=__sv_16;}if(__sv_19!==undefined||("label" in __sv_9)){__o_10["label"]=__sv_19;}if(__sv_20!==undefined||("theme" in __sv_9)){__o_10["theme"]=__sv_20;}if(__sv_39!==undefined||("thankYouHeadline" in __sv_9)){__o_10["thankYouHeadline"]=__sv_39;}if(__sv_40!==undefined||("thankYouBody" in __sv_9)){__o_10["thankYouBody"]=__sv_40;}if(__sv_43!==undefined||("thankYouCta" in __sv_9)){__o_10["thankYouCta"]=__sv_43;}if(__sv_46!==undefined||("thankYouLoggedOutCta" in __sv_9)){__o_10["thankYouLoggedOutCta"]=__sv_46;}if(__sv_49!==undefined||("signInBanner" in __sv_9)){__o_10["signInBanner"]=__sv_49;}if(__sv_52!==undefined||("additionalFormFields" in __sv_9)){__o_10["additionalFormFields"]=__sv_52;}__sv_9=__o_10;}
var __o_0={"sys":__sv_1,"fields":__sv_9};_d=__o_0;}

if(_e.length===0){return{success:true,data:_d};}
return __zcFin(_e,_d);
}
return __zcMkv(safeParse_TemplateUniverse23WaitlistSchema,__zs,null,null);
})()

export type TemplateUniverse23Waitlist = z.infer<typeof TemplateUniverse23WaitlistSchema>
